var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9231 2.5H5.07692C3.38031 2.5 2 3.88031 2 5.57692V15.4231C2 17.1197 3.38031 18.5 5.07692 18.5H14.9231C16.6197 18.5 18 17.1197 18 15.4231V5.57692C18 3.88031 16.6197 2.5 14.9231 2.5ZM10.7957 13.7572C11.036 13.5169 11.4255 13.5169 11.6658 13.7572C11.9062 13.9972 11.9062 14.3871 11.6658 14.6274L10.4354 15.8582C10.32 15.9735 10.1637 16.0385 10.0003 16.0385C9.83692 16.0385 9.68062 15.9735 9.56492 15.8582L8.33446 14.6274C8.09415 14.3871 8.09415 13.9972 8.33446 13.7572C8.57477 13.5169 8.96431 13.5169 9.20492 13.7572L9.38462 13.9372V7.06338L9.20492 7.24338C8.96462 7.48369 8.57508 7.48369 8.33446 7.24338C8.09415 7.00308 8.09415 6.61354 8.33446 6.37292L9.56492 5.14215C9.796 4.91138 10.2046 4.91138 10.4354 5.14215L11.6658 6.37292C11.9062 6.61323 11.9062 7.00277 11.6658 7.24338C11.5455 7.36338 11.3883 7.42338 11.2308 7.42338C11.0732 7.42338 10.916 7.36339 10.7957 7.24308L10.6157 7.06308V13.9369L10.7957 13.7572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.795e5ef1a9dfae030e6036b8c412daf2.svg";
export { ForwardRef as ReactComponent };